// flow weak

import React, {
  PureComponent
}                         from 'react';
import PropTypes          from 'prop-types';
import {
  AnimatedView,
  StatsTable,ScoreCard,StatsGraph
}                         from '../../../components';

import {
  TabPanel,
  TabPanelHeader,
  TabPanelBody,
  TabPanelBodyContent
} from '../../../components';
import {Link} from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';

class PartnerRental extends PureComponent {
  static propTypes = {
    earningGraphLabels:   PropTypes.array,
    revenueChart:  PropTypes.shape({
      headers: PropTypes.array,
      data: PropTypes.array
    }),
    earningGraphDatasets: PropTypes.array,
    teamMatesIsFetching:  PropTypes.bool,
    teamMates:            PropTypes.arrayOf(
      PropTypes.shape({
        picture:      PropTypes.string,
        firstname:    PropTypes.string,
        lastname:     PropTypes.string,
        profile:      PropTypes.string,
        profileColor: PropTypes.oneOf(['danger', 'warning', 'info', 'success'])
      })
    ),
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  state = {
    rental_revenue_per_month_graph_tabs: [   
      {name: 'Data', tablink: '1', isActive: true},
      {name: 'Revenue per month', tablink: '2', isActive: false},
    ],
    rental_revenue_per_day_graph_tabs: [  
      {name: 'Data', tablink: '3', isActive: true}, 
      {name: 'Revenue per day', tablink: '4', isActive: false},
    ]    
  };   

  componentWillMount() {
    const { actions: { enterPage } } = this.props;
    enterPage('PartnerRental');
  }

  componentDidMount() {
    const {
      actions: {
        fetchStatsTableDataIfNeeded,
      }
    } = this.props;

  }

  componentWillUnmount() {
    const { actions: { leavePage } } = this.props;
    leavePage('PartnerRental');
  }

  render() {
    const {
      statsTable, scoreCard,statsGraph
    } = this.props;

    const {
      actions: {
        fetchStatsTableDataIfNeeded,fetchScoreCardDataIfNeeded,fetchStatsGraphDataIfNeeded
      }
    } = this.props;
    console.log('stats')
    console.log(statsGraph)
    return(
      <div>
        <div className="row" style={{padding: '1%'}}>
          <Link to="./crud/addRental">
            <RaisedButton
              label="Block Court"
              style={{float:'right'}}
              secondary={true}
            />
          </Link>
        </div>
        <div className="row" style={{padding: '1%'}}>
          <Link to="./crud/addBulkBooking">
            <RaisedButton
              label="Bulk Booking"
              style={{float:'right'}}
              secondary={true}
            />
          </Link>
        </div>
        <div className="row">

          <div className="row">
            <ScoreCard name="rental_score_card" data={scoreCard} reloadData={fetchScoreCardDataIfNeeded}/>
          </div>        

          <div className="row">
            <StatsTable bigTable={true} datefilter={true} name="partner_rental_grid" displayName="Court Utilization" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>

          <div className="row">
            <div className="col-md-6">
            <TabPanel>
              <TabPanelHeader tabItems={this.state.rental_revenue_per_month_graph_tabs}/>
              <TabPanelBody>
                <TabPanelBodyContent id="1">
                <StatsTable name="partner_rental_per_month" color="#29ea92" displayName="Rent per Month"
                  data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="2">
                <StatsGraph type="line" name="graph_partner_rental_per_month" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
              </div>
              <div className="col-md-6">
              <TabPanel>
              <TabPanelHeader tabItems={this.state.rental_revenue_per_day_graph_tabs}/>
              <TabPanelBody>
                <TabPanelBodyContent id="3">
                <StatsTable name="partner_rental_per_day" color="#F05050" displayName="Rent per Day"
                  data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
                </TabPanelBodyContent>
                <TabPanelBodyContent id="4">
                <StatsGraph type="line" name="graph_partner_rental_per_day" data={statsGraph} reloadData={fetchStatsGraphDataIfNeeded}/>
                </TabPanelBodyContent>
              </TabPanelBody>
            </TabPanel>
              </div>
          </div>

          <div className="row">
            <StatsTable bigTable={true} name="partner_rental" displayName="Court Bookings List" data={statsTable} reloadData={fetchStatsTableDataIfNeeded}/>
          </div>
        </div>
      </div>
    );
  }
}

export default PartnerRental;



// WEBPACK FOOTER //
// ./src/app/views/partner/partnerRental/PartnerRental.js